/**
 *
 * Asynchronously loads the component for AI Studio
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LambdaStudio = lazyLoad(
  () => import('./index'),
  module => module.LambdaStudio,
);
